import { LoggerService } from './logger.service';

export const dsLogger = LoggerService.create('ds');
